// Keep this file small and low imports as it's added to the main bundle
import { PreviewModeState } from "./preview-state";

export const shouldShowPreviewModeUi = () => {
  return PreviewModeState.getActiveAndSet();
};
